import {
  UPDATE_MAKE_A_CLAIM,
  RESET_MAKE_A_CLAIM,
  UPDATE_MAKE_A_CLAIM_PROPERTIES,
  UPDATE_NAV_FROM_CLAIMS
} from "../../actions/makeAClaim/MakeAClaimActions";


const initialState = {
  claimType: null,
  isNewClaim: null,
  requiresAuthorisation: null,
  iframeSrc: null,
  action: null,
  preAuth: null,
  claimBackOption: null,
  nhsChemoRadioTreatmentType: null,
  authoriseTreatmentCondition: null,
  isThePatient: null,
  navigationFromClaims:false,
 
};

export default (state = initialState, action) => {
  if (action.type === UPDATE_MAKE_A_CLAIM) {
    return {
      ...state,
      [action.payload.propName]: action.payload.propValue
    };
  } else if (action.type === UPDATE_MAKE_A_CLAIM_PROPERTIES) {
    return {
      ...state,
      ...action.payload
    };
  } 
  else if(action.type ===  UPDATE_NAV_FROM_CLAIMS){
    return{
      ...state,
      navigationFromClaims:action?.payload?.navigationFromClaims
    };
  }
  else if (action.type === RESET_MAKE_A_CLAIM) {
    return initialState;
  }
  return state;
};
